
export default {
  namespaced:true,
  state:{
      dataCampus:[],
      idCampus: null,
  },
  mutations:{
      addCampus(state,payload){
        state.dataCampus = payload;
      },
      setIdCampus(state, id) { 
        state.idCampus = id;
      },  
  },
  actions:{
      addCampus({commit},payload){
          commit('addCampus',payload);
      },
      setIdCampus({ commit }, id) { 
        commit('setIdCampus', id);
      },
  },
  getters:{
     
  }
}